import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 文書管理 一覧
        documentIndexInfos: {
            // 検索項目
            searchItem: {
            },
            // 検索結果かどうか
            searchResult: {
            }
        },
    },
    getters: {
        getDocumentIndexInfos(state){
            return state.documentIndexInfos;
        },
    },
    mutations: {
        saveDocumentIndexInfos(state, infos) {
            state.documentIndexInfos = infos.indexInfo;
            state.documentIndexInfos.searchItem = infos.searchItem;
            state.documentIndexInfos.searchResult = infos.searchResult;
        }
    },
    actions: {
    },
    modules: {
    },
    plugins: [
        createPersistedState(
            {
                key: 'documentIndexInfos',  // keyを指定したい場合は「vuex」がkeyになる
                paths: ['documentIndexInfos'],  // 保存するstate または モジュールを指定（未指定だと全てが対象）
                storage: window.sessionStorage,  // セッションストレージに保存
            }
        )
    ],
})